import './Donate.css';
import Navbar from "../../components/Navbar/Navbar";
import Footer from '../../components/Footer/Footer';
import BackToTop from "../../components/BackToTop/BackToTop";
import PageHeader from '../../components/PageHeader/PageHeader';
import { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import harvestImg from '../../assets/images/school/harvest.png';

export default function Donate() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [amount, setAmount] = useState("50");
    const [currency, setCurrency] = useState("GHS");
    const [country, setCountry] = useState("Ghana");
    const MySwal = withReactContent(Swal);

    useEffect(() => {
        window.scrollTo(0, 0);
        // Load Paystack script
        const script = document.createElement("script");
        script.src = "https://js.paystack.co/v1/inline.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);

    const handlePaystackPayment = () => {
        const paystack = (window as any).PaystackPop;
        if (!paystack) {
            MySwal.fire('Error', 'Payment gateway failed to load. Please try again.', 'error');
            return;
        }

        // Convert amount to kobo/pesewas (multiply by 100)
        const amountInSubunit = parseFloat(amount) * 100;

        const handler = paystack.setup({
            key: 'pk_test_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx', // Replace with actual public key
            email: email,
            amount: amountInSubunit,
            currency: currency,
            metadata: {
                custom_fields: [
                    {
                        display_name: "Donor Name",
                        variable_name: "donor_name",
                        value: name
                    }
                ]
            },
            callback: function(response: any) {
                MySwal.fire({
                    title: 'Payment Successful!',
                    text: `Reference: ${response.reference}. Thank you for your support!`,
                    icon: 'success'
                });
            },
            onClose: function() {
                MySwal.fire('Cancelled', 'You have cancelled the payment process.', 'info');
            }
        });

        handler.openIframe();
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!email || !name || !amount) {
            MySwal.fire('Wait!', 'Please fill all the fields.', 'warning');
            return;
        }

        MySwal.fire({
            title: 'Confirm Donation',
            text: `You are donating ${currency} ${amount} from ${country}. Proceed to secure payment?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, Donate',
            confirmButtonColor: '#6FBF3A',
        }).then((result) => {
            if (result.isConfirmed) {
                handlePaystackPayment();
            }
        });
    };

    return (
        <div className="donate-page">
            <Navbar />
            <PageHeader title="Support Our Mission" path="/donate" name="Donate" backgroundImage={harvestImg} />

            <section className="donation-section py-5">
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6">
                            <div className="donation-content">
                                <span className="pill-title">&bull; MAKE AN IMPACT</span>
                                <h2 className="display-4 font-weight-bold mb-4" style={{fontFamily: 'Cormorant Garamond, serif'}}>Empowering Growth Through Your Support</h2>
                                <p className="lead mb-4">Your contribution directly funds technical agricultural education and ecological restoration projects across Ghana.</p>
                                
                                <div className="payment-modes mt-4 p-3 bg-light rounded border-left border-success">
                                    <h5 className="mb-3 font-weight-bold">Supported Payment Methods:</h5>
                                    <div className="d-flex gap-4 flex-wrap">
                                        <div className="mode-item"><i className="fas fa-mobile-alt mr-2 text-success"></i> Mobile Money (MTN, Telecel)</div>
                                        <div className="mode-item"><i className="fas fa-university mr-2 text-primary"></i> Bank Transfer</div>
                                        <div className="mode-item"><i className="fas fa-credit-card mr-2 text-danger"></i> Credit/Debit Cards</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="donation-form-wrap p-4 p-md-5 shadow-lg bg-white rounded-3 border-top border-success border-4">
                                <h3 className="text-center mb-4" style={{fontFamily: 'Cormorant Garamond, serif'}}>Secure Donation Portal</h3>
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">Full Name</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Isaac Agyiri" 
                                            value={name}
                                            onChange={(e) => setName(e.target.value)} 
                                            required 
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Email Address</label>
                                        <input 
                                            type="email" 
                                            className="form-control" 
                                            placeholder="isaac@example.com" 
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)} 
                                            required 
                                        />
                                    </div>

                                    <div className="row g-3 mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label">Select Country</label>
                                            <select 
                                                className="form-select" 
                                                value={country}
                                                onChange={(e) => {
                                                    setCountry(e.target.value);
                                                    setCurrency(e.target.value === "Ghana" ? "GHS" : "USD");
                                                }}
                                            >
                                                <option value="Ghana">Ghana</option>
                                                <option value="Nigeria">Nigeria</option>
                                                <option value="South Africa">South Africa</option>
                                                <option value="International">International (USD)</option>
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Currency</label>
                                            <input type="text" className="form-control bg-light" value={currency} readOnly />
                                        </div>
                                    </div>

                                    <div className="mb-4">
                                        <label className="form-label">Donation Amount</label>
                                        <div className="input-group input-group-lg">
                                            <span className="input-group-text">{currency === 'GHS' ? '₵' : '$'}</span>
                                            <input 
                                                type="number" 
                                                className="form-control" 
                                                value={amount}
                                                onChange={(e) => setAmount(e.target.value)}
                                                required 
                                            />
                                        </div>
                                    </div>

                                    <button type="submit" className="btn btn-custom w-100 py-3 font-weight-bold shadow-sm">
                                        Proceed to Paystack <i className="fas fa-external-link-alt ml-2"></i>
                                    </button>
                                    
                                    <div className="payment-security mt-4 text-center">
                                        <img src="https://checkout.paystack.com/static/media/paystack-badge.a0233486.png" alt="Secured by Paystack" style={{height: '20px', opacity: 0.7}} />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
            <BackToTop />
        </div>
    );
}